import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Card, Tag, Button, Modal } from "antd";
import {
  req_list_pim_flexible_group,
  req_del_pim_flexible_group,
} from "../../api";
import { getDateYYYYMM, formateDateDbT_YMD } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import FlexibleLogGroupStaffModal from "./flexible-log-group-staff-modal";
import FlexibleLogGroupAddModal from "./flexible-log-group-add-modal";
import FlexibleLogGroupImportModal from "./flexible-log-group-import-modal";

class FlexibleLogGroup extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: window.innerWidth,
    nowYearMonth: getDateYYYYMM(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    searchField: "None",
    searchValue: "",
    data: [],
    item: {},
    isShowGroupStaffModal: false,
    isShowAddModal: false,
    isUploadModal: false,
  };

  UNSAFE_componentWillMount() {
    window.removeEventListener("resize", this.resize.bind(this));
    this.init_columns();
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_item_list();
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_item_list = async () => {
    const { searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true, data: [] });
    const result = await req_list_pim_flexible_group(
      userLevel,
      userCode,

      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items, loading: false });
      console.log(items);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
      });
    }
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_del_pim_flexible_group(key, token);

    if (result.status === "success") {
      this.handle_data_refresh();
    } else {
    }
  };

  // 樣式設定 //////////////////////////////////////////////
  statusWorkDescription = (Status) => {
    switch (Status) {
      case "PASS":
        return "停班";
      case "WORK":
        return "上班";
      default:
        return "待定";
    }
  };

  style_switch_color_tag = (column, param) => {
    switch (column) {
      case "REASON":
        switch (param) {
          case "工作日":
            return "blue";
          case "休息日":
            return "green";
          case "例假日":
          case "國定假日":
          case "停班停課":
            return "red";
          case "休假日":
            return "gold";
          case "平假日調換":
            return "purple";
          case "工作日調移":
            return "Tan";
          default:
            return "default";
        }
      case "WEEK":
        switch (param) {
          case "週一":
          case "週二":
          case "週三":
          case "週四":
          case "週五":
            return "blue";
          case "週六":
            return "green";
          case "週日":
            return "red";
          default:
            return "default";
        }
      case "STATUS":
        switch (param) {
          case "PASS":
            return "red";
          case "WORK":
            return "blue";
          default:
            return "blue";
        }
      default:
        return "blue";
    }
  };
  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_item_list();
  };

  handle_btn_del = (item) => {
    const { Id } = item;
    Modal.confirm({
      title: `您確定刪除此筆資料嗎?`,
      onOk: () => {
        this.api_delete_item(Id);
      },
    });
  };

  handle_btn_add_single = () => {
    this.setState({ isShowAddModal: true });
  };
  handle_btn_add_multiple = () => {
    this.setState({ isUploadModal: true });
  };
  handle_btn_staff = (item) => {
    this.setState({ item: item, isShowGroupStaffModal: true });
  };

  // 欄位設定 /////////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "操作",
        width: "60px",
        align: "center",
        fixed: "true",
        render: (item) => {
          return (
            <>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => this.handle_btn_del(item)}
              >
                <i className="fas fa-calendar-times"></i> 刪除
              </button>
            </>
          );
        },
      },
      {
        title: "明細",
        width: "120px",
        align: "center",
        fixed: "true",
        render: (item) => {
          const { StaffTotal } = item;
          return (
            <>
              <button
                className="btn btn-info btn-sm"
                onClick={() => this.handle_btn_staff(item)}
              >
                <i className="fas fa-users-cog"></i> 人員{" "}
                <Tag color="orange"> {StaffTotal} </Tag>
              </button>
            </>
          );
        },
      },

      {
        title: "適用群體",
        dataIndex: "GroupName",
        key: "GroupName",
        align: "center",
        width: 120,
        render: (text) => <>{text}</>,
      },
      {
        title: "作息狀態",
        dataIndex: "WorkStatus",
        key: "WorkStatus",
        align: "center",
        width: 90,
        render: (text) => (
          <>
            <Tag color={this.style_switch_color_tag("STATUS", text)}>
              {this.statusWorkDescription(text)}
            </Tag>
          </>
        ),
      },
      {
        title: "起始日期",
        dataIndex: "StartDate",
        key: "StartDate",
        align: "center",
        width: 100,
        render: (text) => <>{formateDateDbT_YMD(text)}</>,
      },
      {
        title: "結束日期",
        dataIndex: "EndDate",
        key: "EndDate",
        align: "center",
        width: 100,
        render: (text) => <>{formateDateDbT_YMD(text)}</>,
      },
      {
        title: "星期",
        dataIndex: "WeekdayName",
        key: "WeekdayName",
        align: "center",
        width: 60,
        render: (text) => (
          <span style={{ color: this.style_switch_color_tag("WEEK", text) }}>
            {text}
          </span>
        ),
      },
      {
        title: "起始時間",
        dataIndex: "StartTime",
        key: "StartTime",
        align: "center",
        width: 60,
        render: (text) => <>{text}</>,
      },
      {
        title: "結束時間",
        dataIndex: "EndTime",
        key: "EndTime",
        align: "center",
        width: 60,
        render: (text) => <>{text}</>,
      },
    ];
  };

  ///////////////////////////////////////////////////////////
  render() {
    const {
      data,
      loading,
      isShowGroupStaffModal,
      isShowAddModal,
      isUploadModal,
      item,
    } = this.state;
    const title = (
      <div>
        <Button type="primary" onClick={() => this.handle_data_refresh()}>
          <i className="fas fa-sync-alt"></i>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_btn_add_single()}>
          <i className="fas fa-calendar-plus"></i>
          <span style={{ marginLeft: "4px" }}>單筆新增</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_btn_add_multiple()}>
          <i className="fas fa-file-import"></i>
          <span style={{ marginLeft: "4px" }}>多筆匯入</span>
        </Button>{" "}
      </div>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          rowKey="Uid"
          columns={this.columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowGroupStaffModal}
          width={700}
          onOk={() => {
            this.setState({ isShowGroupStaffModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowGroupStaffModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <FlexibleLogGroupStaffModal data={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isShowAddModal}
          width={350}
          onOk={() => {
            this.setState({ isShowAddModal: false });
            this.handle_data_refresh();
          }}
          okText={"關閉"}
          onCancel={() => {
            this.setState({ isShowAddModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <FlexibleLogGroupAddModal />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isUploadModal}
          width={300}
          onOk={() => {
            this.setState({ isUploadModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isUploadModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <FlexibleLogGroupImportModal
            item={this.props.location.state}
            creator={this.props.user}
          />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(FlexibleLogGroup);
